import { jsx as _jsx } from "react/jsx-runtime";
import { unicodeCharacters } from '../../utils/constants';
import * as S from './DataView.css';
export const DataViewHeader = ({ headerName, shouldDisplayHeader, }) => (_jsx(S.InfoHeader, Object.assign({ variant: "h3" }, { children: shouldDisplayHeader
        ? headerName
        : `${unicodeCharacters.NON_BREAKING_SPACE}` })));
